var widget_default = {
  "card": "_7vNyf",
  "link": "_9vjte",
  "container": "rZgdw",
  "image": "wJ8nT",
  "right": "dg9wV",
  "cardLayout": "CkKcS",
  "content": "l0DCr",
  "title": "_7d4JR",
  "subtitle": "lfHww",
  "button": "EexkE",
  "button_disabled": "_0QX-L",
  "buttonText": "pG3Oh",
  "slimLayout": "E9Con",
  "contentText": "_45JLm"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
